import {LngLat} from "mapbox-gl";


export function wktPointToLatLng(wktPoint: string): LngLat | null {
  const matches = wktPoint.match(/POINT\s*\((.*?)\s(.*?)\)/i);

  if (matches && matches.length >= 3) {
    const lng = parseFloat(matches[1]);
    const lat = parseFloat(matches[2]);

    if (isNaN(lng) || isNaN(lat)) {
      return null;
    }

    const lngLat =  new LngLat(lng, lat);
    return  lngLat
  }

  return null;
}

/**
 * Parses a Well-Known Text (WKT) string into a GeoJSON geometry object.
 * Requires the 'wellknown' library (https://github.com/mapbox/wellknown)
 * to be loaded globally or imported.
 *
 * @param {string} wktString The WKT string to parse (e.g., 'POINT (30 10)', 'POLYGON ((...))').
 * @returns {object|null} A GeoJSON geometry object (e.g., { type: "Point", coordinates: [30, 10] })
 * if parsing is successful, otherwise null.
 */
export function parseWktToGeoJson(wktString) {
  // Check if the wellknown library is available
  // (This check assumes it's loaded globally via CDN)
  if (typeof wellknown === 'undefined' || typeof wellknown.parse !== 'function') {
    console.error("The 'wellknown' library is not loaded or not available in the current scope.");
    // Depending on your setup, you might need to ensure the library
    // is loaded before this function is called, or adjust the check
    // if you are using import/require.
    return null;
  }

  // Basic input validation
  if (typeof wktString !== 'string' || wktString.trim() === '') {
    console.warn("parseWktToGeoJson: Input must be a non-empty string.");
    return null;
  }

  try {
    const geojsonGeometry = wellknown.parse(wktString);

    // wellknown.parse returns null for invalid WKT, so check for it.
    if (!geojsonGeometry) {
      console.warn(`parseWktToGeoJson: Parsing returned null for WKT: "${wktString}". Input might be invalid WKT format.`);
      return null;
    }
    return geojsonGeometry; // Successfully parsed GeoJSON geometry object

  } catch (error) {
    console.error(`parseWktToGeoJson: Error parsing WKT string "${wktString}"`, error);
    return null; // Return null if an exception occurs during parsing
  }
}
